import { DefinedDefaults, TWithDataComponent } from "@/ui/lib";
import type { HTMLAttributes } from "react";


/*-------------------------------------
|  Constants
|-------------------------------------*/


/*-------------------------------------
|  Types
|-------------------------------------*/

export type TSectionProps = {
} & TWithDataComponent & HTMLAttributes<HTMLElement>;

type TSectionDefaultProps = DefinedDefaults<
  TSectionProps,
  "data-component"
>;

/*-------------------------------------
|  Defaults
|-------------------------------------*/

export const SECTION_DEFAULTS = {
  "data-component": "Section",
} satisfies TSectionDefaultProps;
